var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle2, _circle3, _circle4, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 136,
    viewBox: "0 0 133 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5061,
    cy: 68.3013,
    r: 60.7115,
    fill: "url(#paint0_linear_1731_15536)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1731_15536)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.4033,
    y: 37.668,
    width: 74.8,
    height: 81.4,
    rx: 2.93333,
    fill: "#F3F4F6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.5534,
    y: 58.0188,
    width: 60.5,
    height: 7.7,
    rx: 1.65,
    fill: "#F3F4F6",
    stroke: "#4B74BE",
    strokeWidth: 1.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0034,
    y: 77.2676,
    width: 61.6,
    height: 8.8,
    rx: 2.2,
    fill: "#E5E7EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0034,
    y: 97.0684,
    width: 61.6,
    height: 8.8,
    rx: 2.2,
    fill: "#E5E7EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0034,
    y: 52.334,
    width: 21.2667,
    height: 2.93333,
    rx: 1.46667,
    fill: "#D1D5DB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0034,
    y: 72.1348,
    width: 21.2667,
    height: 2.93333,
    rx: 1.46667,
    fill: "#D1D5DB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0034,
    y: 91.9355,
    width: 21.2667,
    height: 2.93333,
    rx: 1.46667,
    fill: "#D1D5DB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.6695,
    cy: 29.6014,
    r: 1.46667,
    fill: "#F9FAFB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.0695,
    cy: 29.6014,
    r: 1.46667,
    fill: "#4B74BE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.4696,
    cy: 29.6014,
    r: 1.46667,
    fill: "#F9FAFB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_15536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.351 78.8515C84.0895 79.2401 83.9588 79.4345 83.8255 79.4698C83.7099 79.5005 83.5867 79.4728 83.4952 79.3958C83.3898 79.3069 83.3546 79.0753 83.2842 78.6122L81.2864 65.4692C81.2228 65.0511 81.1911 64.8421 81.2597 64.7285C81.3193 64.6299 81.4218 64.5651 81.5365 64.5534C81.6685 64.54 81.8438 64.6582 82.1944 64.8946L93.2165 72.3271C93.6049 72.589 93.7991 72.72 93.8343 72.8533C93.8648 72.969 93.837 73.0922 93.7598 73.1835C93.6708 73.2889 93.4392 73.3238 92.976 73.3936L87.718 74.1866C87.624 74.2007 87.577 74.2078 87.5347 74.2256C87.4973 74.2414 87.4627 74.2632 87.4325 74.2903C87.3983 74.3209 87.3718 74.3603 87.3187 74.4392L84.351 78.8515Z",
    stroke: "#4B74BE",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1731_15536",
    x: 21.5367,
    y: 31.8013,
    width: 86.5334,
    height: 93.1337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.46667,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1731_15536"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.497535 0 0 0 0 0.566854 0 0 0 0 0.670833 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1731_15536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1731_15536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1731_15536",
    x1: 64.5061,
    y1: 130.91,
    x2: 62.9884,
    y2: -33.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D5DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_15536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 17.6,
    fill: "white",
    transform: "translate(72.8682 67.6113) rotate(-32.3251)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.37187f9cb5fae7fd2a64f7f1c018c5e1.svg";
export { ForwardRef as ReactComponent };